import { Link } from 'react-router-dom';
import type { Comic } from '@/mocks/comics';

interface ComicCardProps {
  comic: Comic;
  index?: number;
}

export default function ComicCard({ comic, index }: ComicCardProps) {
  const categoryName = comic.categories[0] === 'hanman' ? '韩漫' : comic.categories[0] === 'rexue' ? '热血' : comic.categories[0] === 'xuanhuan' ? '玄幻' : comic.categories[0] === 'dushi' ? '都市' : comic.categories[0] === 'lianai' ? '恋爱' : '悬疑';

  return (
    <article className="group relative">
      <Link
        to={`/comic/${comic.id}`}
        className="block cursor-pointer"
        aria-label={`阅读《${comic.title}》`}
      >
        <div className="relative overflow-hidden rounded-lg bg-background-200">
          <div className="aspect-[3/4] w-full overflow-hidden">
            <img
              src={comic.cover}
              alt={`${comic.title}漫画封面`}
              title={`${comic.title}漫画免费阅读`}
              className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
            />
          </div>
          {index !== undefined && (
            <span className="rank-badge absolute left-1.5 top-1.5 flex h-7 w-7 items-center justify-center rounded-md bg-primary-500 text-sm font-bold text-background-50 md:h-8 md:w-8">
              {index + 1}
            </span>
          )}
          <span className="absolute right-1.5 top-1.5 rounded-md bg-foreground-950/60 px-1.5 py-0.5 text-[11px] font-medium text-background-50 backdrop-blur-sm md:px-2 md:py-0.5">
            {comic.status}
          </span>
          <div className="absolute inset-x-0 bottom-0 flex translate-y-2 items-center justify-center bg-gradient-to-t from-foreground-950/70 to-transparent py-2.5 opacity-0 transition-all duration-300 group-hover:translate-y-0 group-hover:opacity-100">
            <span className="flex items-center justify-center gap-1 whitespace-nowrap rounded-md bg-primary-500 px-3 py-1 text-xs font-bold text-background-50 md:text-sm">
              <i className="ri-book-open-line h-4 w-4" aria-hidden="true"></i>
              立即阅读
            </span>
          </div>
        </div>
        <h3 className="mt-2.5 truncate text-sm font-bold text-foreground-900 transition-colors group-hover:text-primary-600 md:text-base">
          {comic.title}
        </h3>
        <p className="mt-1 flex items-center gap-2 text-xs text-foreground-500">
          <span className="flex items-center gap-1">
            <i className="ri-fire-fill h-3 w-3 text-accent-500" aria-hidden="true"></i>
            <span className="whitespace-nowrap font-semibold text-accent-600">{comic.rating}分</span>
          </span>
          <span className="flex items-center gap-1 truncate">
            <i className="ri-refresh-line h-3 w-3" aria-hidden="true"></i>
            <span className="truncate">{comic.latestChapter}</span>
          </span>
          <span className="ml-auto hidden whitespace-nowrap rounded bg-secondary-100 px-1.5 py-0.5 text-[11px] text-secondary-900 sm:block">
            {categoryName}
          </span>
        </p>
      </Link>
    </article>
  );
}